// client-side handler for isomorphic styles
module.exports = function insertCss(styles) {
    return styles._insertCss()
}
